import { useEffect, useState } from 'react';

import { useBxpWebStargateClient } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client';
import { type LocaleType } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';

// Matches the consent-hub fallback: assume opt-in is required until we know otherwise.
const DEFAULT_CONSENT_CONFIG: LocaleType = {
	locale: 'UNKNOWN',
	localeRequiresMarketingCommunicationOptIn: true,
};

export const useConsentConfig = (): LocaleType => {
	const stargateClient = useBxpWebStargateClient();
	const [consentConfig, setConsentConfig] = useState(DEFAULT_CONSENT_CONFIG);

	useEffect(() => {
		let isSubscribed = true;

		stargateClient
			?.getConsentConfig()
			.then((config) => {
				if (isSubscribed && config) {
					setConsentConfig(config);
				}
			})
			.catch(() => {
				// Keep DEFAULT_CONSENT_CONFIG.
			});

		return () => {
			isSubscribed = false;
		};
	}, [stargateClient]);

	return consentConfig;
};
